export const LOCATEUS = "LOCATEUS";
export const LOCATEUS_ERROR = "LOCATEUS_ERROR";
export const LOCATEUS_HIDE_ERROR = "LOCATEUS_HIDE_ERROR";
export const LOCATEUS_START_LOADER = "LOCATEUS_START_LOADER";
export const LOCATEUS_STOP_LOADER = "LOCATEUS_STOP_LOADER";
